import React, { useContext, useEffect } from 'react';
import { ContextBuilder } from '../../../context/builder/reducers';
import Input from './Input';

export default (props) => {
    const { state, dispatch } = useContext(ContextBuilder);
    useEffect(() => {
        if (!props.content) {
            const data = state.data;
            data.value[props.index].content = {
                title: '', subTitle: ''
            }
            dispatch({ type: 'data', payload: { data } })
        }
    });

    const content = props.content || { title: '', subTitle: '' };

    const onTitleChange = (index, name, text) => {
        const data = state.data;
        data.value[props.index].content.title = text;
        dispatch({ type: 'data', payload: { data } });
    }

    const onSubTitleChange = (index, name, text) => {
        const data = state.data;
        data.value[props.index].content.subTitle = text;
        dispatch({ type: 'data', payload: { data } });
    }

    return (
        <div className="header">
            <h2>Header</h2>
            <div className="row">
                <div className="col-6">
                    <label>Title</label>
                    <Input value={content.title} onChange={onTitleChange}/>
                </div>
                <div className="col-6">
                    <label>Title</label>
                    <Input value={content.subTitle} onChange={onSubTitleChange}/>
                </div>
            </div>
        </div>
    );
}
